import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const AppComponent = React.lazy(() =>
  process.env.REACT_APP_MODE === 'private'
    ? import('./QS_App')
    : import('./App')
);

const RootComponent = () => {
  useEffect(() => {
    const mode = process.env.REACT_APP_MODE || 'public';
    if (mode === 'private') {
      document.title = 'Tuyển sinh BQP (QS)';
      // document.getElementById('favicon')?.setAttribute('href', '/private-favicon.ico');
      // document.getElementById('apple-touch-icon')?.setAttribute('href', '/private-icon.png');
    } else {
      document.title = 'Tuyển sinh Bộ Quốc phòng';
      // document.getElementById('favicon')?.setAttribute('href', '/BTTM.ico');
      // document.getElementById('apple-touch-icon')?.setAttribute('href', '/ADM.png');
    }
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AppComponent />
    </Suspense>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

reportWebVitals();